import React, { useState,useRef } from 'react';
import FormHelper from '../../../components/FormBuilder/FormHelpers';
import {FieldLabel, Description, RequiredMsg, SelectedCount} from '../FieldLabel';
import {CueTip} from '../../../components/Common/CueTooltip';
import { Spinner } from '../../Common/Spinner';

const SEARCH_WAIT_INTERVAL = 500;
let searchKeyword = null;
let timer = null;

const InputMultiSelectSearch = ({labelLocale, renderField, field, position, formData, readOnly, errors, forceUpdate, formFn, isFormWizard, openFieldLabelModal, currentLocale}) => {
  const clientId = field.client_id;
  let pagenate = formFn[clientId+'_pagenate'] || {};
  let resultPath = formFn[clientId+'_path'] || 'label';
  let listKey = clientId+'_array';
  const modifiedFlag = clientId + '_is_modified';
  formData[listKey] = formData[listKey] || [];

  let [modelarray, setModelarray] = useState(formData[listKey]);
  let [list, setList] = useState([]);
  let [loading, setLoading] = useState(false);
  const [noResultFound, setNoResultFound] = useState(false);
  const inputEl = useRef(null);

  if(!renderField){
    return null;
  }

  let inputAttributes = {
    'id': clientId,
    'name': clientId,
    'placeholder': labelLocale(5),
    'disabled':readOnly,
    'className':'form-input form-input-gray form-input-full'
  }
  
  let parentAttributes = {
    'tooltip': field.tooltip
  }
  
  let labelAttributes = FormHelper.setLabelStyle(field, isFormWizard, parentAttributes);
      
  const handleChange = (event) => {
    clearTimeout(timer);
    searchKeyword = event.target.value;
    pagenate.page = 1;
    timer = setTimeout(onSearch, SEARCH_WAIT_INTERVAL);
  }

  const onSearch = () => {
    /*if(searchKeyword && searchKeyword != ''){*/
      try{
        setNoResultFound(false);
        setLoading(true);
        formFn['get_'+clientId]((searchKeyword || ''), onSuccessCallback, onFailureCallback);
        //showResultSet = true; 
        //onChange(search);
      }catch(e){
        setLoading(false);
        console.log(e);
      }
    /*}else{
      setList([])
      formData[clientId] = null
      setError(true)
    }*/
  }

  const onSuccessCallback = (resultList) =>{
    if(resultList.length == 0) setNoResultFound(true);
    setLoading(false);
    setList(resultList);
  }

  const onFailureCallback = (error) =>{
    setLoading(false);
    setList(error);
  }

  const next = (e) => {
    if((pagenate.page+1) <= pagenate.pageSize){
      pagenate.page += 1; 
      onSearch();
    }
  }

  const previous = (e) => {
    if((pagenate.page - 1) > 0){ 
      pagenate.page -= 1; 
      onSearch();
    }
  }

  /* 
   * To check an item exist in checkbox options.
   */
  const toggle = (item, addItem=true) => {
    if(addItem && field.max && modelarray.length >= field.max) return;
    const selectedItems = formFn['toggle_'+clientId](item);
    formFn[modifiedFlag] = true;
    setModelarray([...selectedItems]);
    setError();
  }

  const toggleAll = () =>{
    for(const item of list){
      toggle(item);
    }
  }

  const exists = (item) => {
    return formFn['exist_'+clientId](item);
  }

  const onSelectItem = (item) =>{
    const onSelectFn = formFn['select_'+clientId];
    onSelectFn && onSelectFn(item);
  }

  const bindWindowClickEvent = () =>{
    let el = document.getElementById(clientId+'_result_set');
    el.classList.remove("hidden");
    window.addEventListener('click', eventFunction);
  }

  const eventFunction = (event) => {
    try{
      if(document.getElementById(clientId+'_container').contains(event.target)){
        //console.log(field)
      }else{
        let el = document.getElementById(clientId+'_result_set');
        el.classList.add("hidden");
        window.removeEventListener("click",eventFunction);
        forceUpdate();
      }
    }catch(e){
    
    }
  }

  const close = () =>{
    /*let el = document.getElementById(clientId+'_result_set');
    el.classList.add("hidden");*/
    setList([]);
    inputEl.current.blur();
    onCloseTrigger();
  }

  const removeFocus = () =>{
    setList([]);
    inputEl.current.blur();
    onCloseTrigger();
  }

  const onCloseTrigger = () =>{
    if(formFn[modifiedFlag]){
      const onCloseFn = formFn['on_close_' + clientId];
      onCloseFn && onCloseFn();
    }
    formFn[modifiedFlag] = false;
  }

  //FormHelper.setDisabled(field, inputAttributes);

  const setError = (event) => {
    if(field.required){
      const name = clientId;
      errors[name].invalid = formData[listKey].length==0?true:false;
      errors[name].touched = true;
      if(errors[name].invalid){
        errors.invalid[name] = true;
      }else{
        delete errors.invalid[name];
      }
    }
  }
  
  const Error = () => {
    if(field.required && (errors[clientId].touched || errors.isSubmitted) && errors[clientId].invalid){
      return(
        <div className="errormsg">
          <div>
            <span className="fas fa-exclamation-triangle m-r-5"/>
            <RequiredMsg {...{field, currentLocale}}/>
          </div>
        </div>
      )
    }else if(noResultFound){
      return(
        <div className="errormsg">
          <div>No Result Found</div>
        </div>
      )
    }
    return null;
  }

  return (
    <div {...parentAttributes} onMouseLeave={() => removeFocus()}>
      <div className="flex coldir m-b-20 tooltip">
        <CueTip 
          positionCss={position>1?'top':'bottom'}
          tooltip={field.tooltip}
          currentLocale={currentLocale}
          locale={field.locale?.tooltip}/>
        <FieldLabel field={field} 
          isFormWizard={isFormWizard}
          labelAttributes={labelAttributes} 
          currentLocale={currentLocale}
          openFieldLabelModal={openFieldLabelModal}/>
        {loading && <Spinner></Spinner>}
        <div className={`form-input-gray fstElement fstMultipleMode ${readOnly && 'input-readonly'}`} id={clientId+ '_container'}>
        {list ? 
          <OptionsObjList list={list} toggle={toggle} handleChange={handleChange}
            exists={exists} modelarray={modelarray} field={field} resultPath={resultPath}
            inputAttributes={inputAttributes} close={close} onSelectItem={onSelectItem} 
            pagenate={pagenate} next={next} onSearch={onSearch} toggleAll={toggleAll}
            previous={previous} inputEl={inputEl}/> 
          :
          null
        }   
        </div>  
        <Description description={field.description} currentLocale={currentLocale} locale={field.locale?.description}/>
        <SelectedCount label={field.label} show={formFn.showSelectedCount} count={modelarray.length}/>
        <Error/>
      </div>
      {/*<APIRequestEle {...{formFn, field, formData}}/>*/}
    </div> 
  )
}

const OptionsObjList = ({ inputEl, onSearch, pagenate, next, previous, onSelectItem, toggleAll, list, toggle, exists, modelarray, field, inputAttributes, handleChange, resultPath, close}) => {

  const selectableItems = list.map((o, k) =>{
    const selected = exists(o);
    return(  
      <span key={k} 
        className={`fstResultItem ${selected ? 'fstSelected' : ''} `}
        onClick={e => toggle(o, !selected)} title={o.description}>
          {o[resultPath]}
      </span>
    )
  })

  const selectedItems = modelarray.map((i, k) =>  
    <div key={k} className="fstChoiceItem">
      <span onClick={e => onSelectItem(i)}>{i[resultPath]}</span>
      <span className="fstChoiceRemove" type="button" onClick={e => toggle(i, false)}>×</span>
    </div>
  )

  return(
    <>
      <div className="fstControls">
        <div className="fstSelected">{selectedItems}</div>
        <input {...inputAttributes} onChange={e=>handleChange(e)} onFocus={() => onSearch()} 
        ref={inputEl} className="fstQueryInput" 
        autoComplete="off"/>
      </div>
      { (list.length > 0) &&
        <div className="fstResults">
          <div className="flex rowrev cgap-20 m-t-5 p-r-15">
            <span className="pill bg-highlight white" onClick={()=>close()}>Close</span>
            <span className="pill bg-highlight white" onClick={()=>toggleAll()}>Toggle All</span>
          </div>
          {pagenate.pageSize > 1 ? 
            <ul className="pager">
              <li onClick={e => previous(e)}><span>Previous</span></li>
              <li onClick={e => next(e)}><span>Next</span></li>
              <small className="m-l-15">{pagenate.page} of {pagenate.pageSize}</small>
            </ul>
            : null
          } 
          {selectableItems}
        </div>
      }
    </>
  )
}

export default InputMultiSelectSearch;